import React from "react";


const GuestContainer = (props)=>{
    return (
        <main className="login-area ">
            {props.children}
        </main>
    )
}

export default GuestContainer;